// Keep every product URL inside the route's single `:product_id` segment.
// Product names (and some legacy backend slugs) can contain `/`, which would
// otherwise be interpreted as another path segment and send the user to 404.
const makeRouteSafe = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\\/]+/g, "-")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

// Prefer the backend slug when available, while sanitizing legacy values too.
// Older products without a slug continue to use a name-derived URL.
export const toProductSlug = (product) =>
  makeRouteSafe(product?.slug || product?.name) ||
  String(product?.product_id || "product");
